import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'

export default class WishlistButton extends HTMLAnchorElement {
    connectedCallback() {
        this.watch();
    }

    /**
     * Écoute les événements.
     */
    watch() {
        this.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggleWishlist();
        })
    }

    /**
     * Envoie la requête pour ajouter/supprimer le favori.
     */
    toggleWishlist() {
        const requestor = new Requestor();
        requestor.sendRequest(this.dataset.href, 'PUT', {
            '_token': document.querySelector('meta[name="csrf-token"]').content,
        }, this.wishlistCallback.bind(this));
    }

    /**
     * Retour de la requête d'ajout/suppression du favori.
     * Ajuste la class du bouton.
     */
    wishlistCallback(data) {
        if (data.success) {
            if (data.isFavorite) {
                this.classList.add("active");
            } else {
                this.classList.remove("active");
            }
        }
    }
}
